import { useEffect } from "react"

import useFetch from "shared/model/useFetch"

const useGetAccountStoreTicket = () => {
    const [fetchResult, fetchRequest] = useFetch()

    useEffect(() => {
        fetchRequest("GET", "/account/store-ticket")
    }, [])

    return [fetchResult]
}

export default useGetAccountStoreTicket